import { ActionPayload, ID } from "../../types";
import * as types from "../constants/ActionTypes";

export interface HiddenPayload {
  id: ID;
}
export const addHidden = (id: ID): ActionPayload<HiddenPayload> => {
  return {
    type: types.ADD_HIDDEN,
    payload: {
      id,
    },
  };
};

export const removeHidden = (id: ID): ActionPayload<HiddenPayload> => {
  return {
    type: types.REMOVE_HIDDEN,
    payload: {
      id,
    },
  };
};
